import App from '../cart/index.svelte';

document.addEventListener('DOMContentLoaded', () => {
  const cart = new App({
    target: document.getElementById('cart_app'),
    props: props
  });

  window.cart = cart;
})
